module.exports = __webpack_public_path__ + "afc4fbaea7ed26cab8db95931c2a9d13.MP3";